import { MONTHLY_FEES } from "../constants/guidelineCharges";
import BusinessPermissions from "../../../Adviser/Constants/BusinessPermissions";

const normalise = (value) => String(value || "").trim().toLowerCase();

export const toMonthlyFeeDateValue = (value) => {
  if (!value) return "";

  if (typeof value === "string") {
    const trimmed = value.trim();
    const isoDate = trimmed.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (isoDate) return `${isoDate[1]}-${isoDate[2]}-${isoDate[3]}`;

    const isoMonth = trimmed.match(/^(\d{4})-(\d{2})$/);
    if (isoMonth) return `${isoMonth[1]}-${isoMonth[2]}-01`;

    const ukDate = trimmed.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (ukDate) return `${ukDate[3]}-${ukDate[2]}-${ukDate[1]}`;
  }

  const date = value?.toDate
    ? value.toDate()
    : value?.seconds != null
      ? new Date(value.seconds * 1000)
      : value instanceof Date
        ? value
        : new Date(value);
  if (Number.isNaN(date.getTime())) return "";

  const parts = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Europe/London",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(date);
  const part = (type) => parts.find((item) => item.type === type)?.value || "";
  return `${part("year")}-${part("month")}-${part("day")}`;
};

export const toMonthlyFeeMonthValue = (value) =>
  toMonthlyFeeDateValue(value).slice(0, 7);

export const getMonthlyFeeStartMonth = (dateAppointed) => {
  const dateValue = toMonthlyFeeDateValue(dateAppointed);
  if (!dateValue) return null;
  const [year, month] = dateValue.split("-").map(Number);
  return month === 12 ? `${year + 1}-01` : `${year}-${String(month + 1).padStart(2, "0")}`;
};

export const findMonthlyFeeGuideline = (status = [], fees = MONTHLY_FEES) => {
  const areas = new Set((Array.isArray(status) ? status : [status]).map(normalise));
  // The constants array is the sole priority order. Only the first match applies.
  return fees.find((fee) => {
    const permissions = fee.permission === "GI/Prot" ? ["GI/Prot", "GI", "PROT"] : [fee.permission];
    return permissions.some((permission) => areas.has(normalise(permission)) ||
      (BusinessPermissions[permission] && areas.has(normalise(BusinessPermissions[permission]))));
  });
};

// Fees start after appointment and end with the month the adviser leaves.
export const isMonthlyFeeApplicable = (adviser, month) => {
  const startMonth = getMonthlyFeeStartMonth(
    adviser.monthlyFeeFromDate || adviser.dateAppointed,
  );
  if (!startMonth || month < startMonth) return false;
  // Without a leaving date, do not invent continuing fees for an unappointed adviser.
  const feeToDate = adviser.monthlyFeeToDate || adviser.dateLeft;
  if (!feeToDate) return adviser.isAppointed !== false;
  const firstExcludedMonth = getMonthlyFeeStartMonth(feeToDate);
  return Boolean(firstExcludedMonth && month < firstExcludedMonth);
};
